// The status a trip should be SHOWN with.
//
// The acting match engine leaves a trip nobody accepted at DISPATCHING — so its
// retries keep running — and stamps `matchFailedAt` instead (cleared when a driver
// accepts). To an operator that is "Driver NOT Accepted", the label the legacy
// `failed` status already has, so it maps onto that. Only acting trips; every
// other trip shows its real status.
export const displayTripStatus = (trip) => {
  if (trip?.isActingDriverTrip && trip?.status === 'DISPATCHING' && trip?.matchFailedAt) {
    return 'failed';
  }
  return trip?.status;
};
